// @flow

import React from 'react';
import styled, { css } from 'styled-components';
import { ifProp, prop } from 'styled-tools';
import { defaultTo } from 'lodash';
import { BarLoader } from 'react-spinners';

type Props = {
  loading?: boolean,
  height?: number,
  pastDelay?: boolean,
  children?: any,
};

const Wrapper = styled.div`
  ${ifProp(
    'loading',
    css`
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      min-height: ${prop('height', 50)}px;

      &::after {
        content: '';
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(255, 255, 255, 0.7);
      }
    `,
  )};
`;

const LoadingPlaceholder = (props: Props) => {
  const loading = defaultTo(props.loading, true);

  // react-loadable passing `pastDelay` flag
  // if chunk wasn't loaded in delay time
  const pastDelay = defaultTo(props.pastDelay, true);

  if (!pastDelay) {
    return null;
  }

  return (
    <Wrapper loading={loading} height={props.height}>
      {loading && <BarLoader />}
      {props.children && props.children}
    </Wrapper>
  );
};

export default LoadingPlaceholder;



// WEBPACK FOOTER //
// ./src/components/LoadingPlaceholder/index.js